import Vue from 'vue'

import AppLayout from './layout/index.vue'
import router from './router'
import store from './store'

import './mixins'
import './plugins'
import './thirdParty'

import './scss/style.scss'
import './assets/fonts/bebasneue.css'
import 'vue-toast-notification/dist/theme-default.css'
import './service-worker'
import JsonExcel from 'vue-json-excel'
import i18n from './i18n'
import frag from 'vue-frag'
import HighchartsVue from 'highcharts-vue'

Vue.component('downloadExcel', JsonExcel)
Vue.directive('frag', frag)
Vue.use(HighchartsVue)
Vue.config.productionTip = false

new Vue({
  name: 'Root',
  router,
  store,
  i18n,
  mounted () {
    store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth)
    window.addEventListener('resize', () => store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth))
  },

  beforeDestroy () {
    window.removeEventListener('resize', () => store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth))
  },
  render: h => h(AppLayout)
}).$mount('#app')
